import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import './styles/main.scss';
import 'element-plus/theme-chalk/el-message.css';
import ElementPlus from 'element-plus';
import locale from 'element-plus/es/locale/lang/zh-cn';

// 引入神策
import sensors from './utils/sensors';
const app = createApp(App);
app.config.globalProperties.$sensors = sensors;
app.use(router);
app.use(pinia);
app.use(ElementPlus, { locale });
app.mount('#app');
